import { ReactNode } from 'react';
import { Box, Flex, Link, Text, VStack } from '@chakra-ui/react';
import { useAuth } from '../hooks/useAuth';
import eyebrightFlower from '../assets/eyebright-flower.png';
import { useCurrentUser } from '../hooks/useCurrentUser';

type AdminRouteProps = {
    children: ReactNode;
}

const InvalidUserMessage = ({message}: {message: string}) => {
    const { logout } = useAuth();

    return (
        <Flex
            height="100vh"
            justifyContent="center"
            alignItems="center"
        >
            <Box p={5} shadow="md" borderWidth="1px">
                <VStack>
                    <img src={eyebrightFlower} width="100"/>
                    <Text>{message}</Text>
                    <Link color={"blue"} onClick={logout}>Logout here</Link>
                </VStack>
            </Box>
        </Flex>
    )
}

const ValidUserRoute = ({ children }: AdminRouteProps) => {
    const { user, readAccess, portalOffline, scheduledResume } = useCurrentUser()

    if (!user) {
        return (
            <InvalidUserMessage message="Invalid user. Please contact your account manager."/>
        );
    }

    if (user && portalOffline) {
        let message = "The portal is temporarily offline for scheduled upgrade.";
        if (scheduledResume) {
            message += " We expect to be back online at " + scheduledResume.toLocaleString("en-GB", { timeZone: "Europe/London" });
        }

        return (
            <InvalidUserMessage message={message} />
        );
    }

    if (user && !readAccess) {
        return (
            <InvalidUserMessage message="You have not been approved for portal access. Please contact your account manager."/>
        );
    }

    return <>{children}</>;
};

export default ValidUserRoute;
